module.exports = __webpack_public_path__ + "static/years_bubble_mobile-3e0d26d962276f81a2e396276d865b83.png";